<template>
  <button
    :type="type"
    :disabled="disabled || loading"
    :class="['q-btn', `q-btn--${variant}`, { 'q-btn--block': block }]"
    @click="$emit('click', $event)"
  >
    <i v-if="loading" class="pi pi-spin pi-spinner q-btn__icon" />
    <i v-else-if="icon" :class="[icon, 'q-btn__icon']" />
    <span v-if="label">{{ label }}</span>
    <slot v-if="!label && !icon" />
  </button>
</template>

<script>
const VARIANTS = ["tipster", "confirma", "cancela", "neutro", "verde", "primary"];

export default {
  name: "QBtn",
  emits: ["click"],
  props: {
    variant: {
      type: String,
      default: "confirma",
      validator: (v) => VARIANTS.includes(v),
    },
    label:    { type: String,  default: null },
    icon:     { type: String,  default: null },
    disabled: { type: Boolean, default: false },
    loading:  { type: Boolean, default: false },
    block:    { type: Boolean, default: false },
    type:     { type: String,  default: "button" },
  },
};
</script>

<style scoped>
.q-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-family: var(--q-font-ui, 'Inter', sans-serif);
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 0.45rem 1.5rem;
  border-radius: 20px;
  border-width: 2px;
  border-style: solid;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.18s, color 0.18s, border-color 0.18s;
  line-height: 1.5;
}
.q-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.q-btn--block {
  width: 100%;
  margin: 0.25rem 0 1rem 0;
}
.q-btn__icon { font-size: 0.95rem; }

/* ── Tipster (oro, outline) — CTA primario ── */
.q-btn--tipster {
  color: var(--q-gold);
  border-color: var(--q-gold);
  background: transparent;
}
.q-btn--tipster:hover:not(:disabled) {
  background: var(--q-gold);
  color: var(--q-gold-on);
}

/* ── Confirma (verde, sólido) ── */
.q-btn--confirma {
  background: var(--q-green);
  border-color: var(--q-green);
  color: #051a0c;
}
.q-btn--confirma:hover:not(:disabled) {
  background: var(--q-green-soft);
  border-color: var(--q-green);
  color: var(--q-green);
}

/* ── Cancela (rojo, sólido) ── */
.q-btn--cancela {
  background: var(--q-red);
  border-color: var(--q-red);
  color: #fff;
}
.q-btn--cancela:hover:not(:disabled) {
  background: var(--q-red-soft);
  border-color: var(--q-red);
  color: var(--q-red);
}

/* ── Neutro (muted, outline) ── */
.q-btn--neutro {
  color: var(--q-muted);
  border-color: var(--q-border-md);
  background: transparent;
}
.q-btn--neutro:hover:not(:disabled) {
  background: var(--q-hover);
  color: var(--q-text);
  border-color: var(--q-muted);
}

/* ── Verde (circular, decorativo) ── */
.q-btn--verde {
  background: linear-gradient(310deg, var(--q-green) 0%, #98ec2d 100%);
  border-color: transparent;
  color: #051a0c;
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 50%;
  font-size: 1.1rem;
}

/* ── Primary (oro, sólido) ── */
.q-btn--primary {
  background: var(--q-gold);
  border-color: var(--q-gold);
  color: var(--q-gold-on);
}
.q-btn--primary:hover:not(:disabled) {
  background: var(--q-gold-hover);
  border-color: var(--q-gold-hover);
}
</style>
